import { render, staticRenderFns } from "./DashboardActivityStream.vue?vue&type=template&id=a94c20b0&scoped=true"
import script from "./DashboardActivityStream.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardActivityStream.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DashboardActivityStream.vue?vue&type=style&index=0&id=a94c20b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94c20b0",
  null
  
)

export default component.exports